import React, { Component } from 'react';
import { connect } from 'react-redux';

import { jsDictionaryEquals } from '../../../../../../../../ressources/functionJS/jsDictionaryEquals';
import styles from './GrapheRapport.module.scss';
import * as actions from '../../../../../../../../services/actions';
import Collapse from '../../../../../../../../hoc/Collapse/Collapse';
import FormulaireSelectionGraphe from '../../../../../../../UI/FormulaireSelectionGraphe/FormulaireSelectionGraphe';

class GrapheRapport extends Component {
  state = {
    // Initialize with default values or empty object if preconfigureObjet doesn't exist
    ...(this.props.preconfigureObjet || {}),
  };

  // Updates state when field value changes
  gererEtatDeCibleName = (event) =>
    this.setState({ [event.target.name]: event.target.value });

  // Single function to handle configuration updates
  updateConfigFromProps = (newConfig) => {
    if (newConfig) {
      this.setState(newConfig);
    }
  };

  componentDidUpdate(prevProps, prevState) {
    // Only update if preconfigureObjet has changed
    if (prevProps.preconfigureObjet !== this.props.preconfigureObjet) {
      this.updateConfigFromProps(this.props.preconfigureObjet);
    }

    // Notify parent if state changed
    if (!jsDictionaryEquals(prevState, this.state)) {
      this.props.gererJson(this.state);
    }
  }

  // Handler for graph ID updates (converted to integer)
  gererGrapheId = (graph_id) =>
    this.setState({ graph_id: parseInt(graph_id, 10) });

  render() {
    return (
      <Collapse
        expandText={
          <div className={styles.contenuEnTete}>
            {this.props.contenuEnTete}
            <span className={styles.titre}>{this.state.text}</span>
            <span className={styles.bold}>
              {' '}
              ID du graphe : {this.props.preconfigureObjet?.graph_id || ''}{' '}
            </span>
          </div>
        }
        expandTextOuvert={
          <div className={styles.contenuEnTete}>
            {this.props.contenuEnTete}
            <span className={styles.titre}>{this.state.text}</span>
          </div>
        }
      >
        <FormulaireSelectionGraphe
          gererGrapheId={this.gererGrapheId}
          preconfigurerGrapheId={this.props.preconfigureObjet?.graph_id}
        />
        {this.props.children}
      </Collapse>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    reqCreerRapportGabarit: (formulaireRapportGabarit) =>
      dispatch(actions.reqCreerRapportGabarit(formulaireRapportGabarit)),
    reqModifierRapportGabarit: (formulaireRapportGabarit) =>
      dispatch(actions.reqModifierRapportGabarit(formulaireRapportGabarit)),
  };
};

export default connect(null, mapDispatchToProps)(GrapheRapport);
